import { QueryClient, QueryKey } from '@tanstack/react-query';
import { getErrorReporter } from 'shared/services/error-tracking';

// Deliberate parallel of @griply/hooks' external-calendar-events queryFn — web-only Sentry; a stable key makes cache read the fallback.
export type CreateContainedQueryFnOptions<T> = {
  queryClient: QueryClient;
  queryKey: QueryKey;
  fetch: () => Promise<T[]>;
  source: string;
};

// a rejection would throw to the route boundary — throwOnError defaults to !!suspense
export const createContainedQueryFn =
  <T>({
    queryClient,
    queryKey,
    fetch,
    source,
  }: CreateContainedQueryFnOptions<T>) =>
  async (): Promise<T[]> => {
    try {
      return await fetch();
    } catch (error) {
      getErrorReporter().captureException(error, { tags: { source } });
      return queryClient.getQueryData<T[]>(queryKey) ?? [];
    }
  };
